import { AgentKnowledgeEnvProvider } from './AgentKnowledgeEnvContext.jsx';
import { AgentKnowledgeDrivesProvider } from './AgentKnowledgeDrivesContext.jsx';
import { AgentKnowledgeDocumentsProvider } from './AgentKnowledgeDocumentsContext.jsx';

/**
 * Wraps Knowledge tab with env + drives + vault-documents providers.
 */
export function AgentKnowledgeProviders({ agent, userId, children }) {
  return (
    <AgentKnowledgeEnvProvider agent={agent} userId={userId}>
      <AgentKnowledgeDrivesProvider>
        <AgentKnowledgeDocumentsProvider>{children}</AgentKnowledgeDocumentsProvider>
      </AgentKnowledgeDrivesProvider>
    </AgentKnowledgeEnvProvider>
  );
}
